const VALID_CURRENCY = /^\s*\$?\d+(\.\d+)?\s*$/

export default function formatCurrency (num, rounded) {
  if (!num || !num.toString().match(VALID_CURRENCY)) return num
  num = parseFloat(num)
  if (rounded) {
    return '$' + Math.round(num)
  } else {
    return '$' + num.toFixed(2)
  }
}
